<template>
  <el-dialog
    title="Sztornó megerősítése"
    :visible="true"
    width="900px"
    append-to-body
    :before-close="cancel"
  >
    <div v-loading="loading">
      <div style="margin-bottom: 20px;">
        Biztos sztornózza a {{ invoiceNumber }} számlát?
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="secondary"
        :loading="buttonLoading"
        @click="cancel"
      >
        Mégsem
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="confirm"
      >
        Mentés
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    invoiceId: {
      type: Number,
      required: true,
    },
    invoiceNumber: {
      type: String,
      required: true,
    },
  },
  methods: {
    cancel() {
      this.$emit('close', false)
    },
    confirm() {
      this.$emit('close', true)
    },
  },
};
</script>
